module.exports = __webpack_public_path__ + "static/dolly4-10ef884cefc5965312de3d892bba6d0a.jpg";